import { render, staticRenderFns } from "./CatalogView.vue?vue&type=template&id=2ffbb0ef&scoped=true"
import script from "./CatalogView.vue?vue&type=script&lang=js"
export * from "./CatalogView.vue?vue&type=script&lang=js"
import style0 from "./CatalogView.vue?vue&type=style&index=0&id=2ffbb0ef&prod&lang=css"
import style1 from "./CatalogView.vue?vue&type=style&index=1&id=2ffbb0ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffbb0ef",
  null
  
)

export default component.exports